export default {"src":"/_next/static/media/dentalCare.1537e4e0.svg","height":25,"width":29,"blurWidth":0,"blurHeight":0};